export default __webpack_public_path__ + "static/map-mobile-9bf02526b12cc12d42720a9e772e7bb5.svg";